import { useNavigate } from "react-router-dom";

import {
  orderMinimumBlockActions,
  useOrderMinimumBlock
} from "~/stores/kiosk-session/order-minimum-block";

import { ModalOrderMinimum } from "./modal-order-minimum";

export const OrderMinimumBlockModal = () => {
  const navigate = useNavigate();
  const products = useOrderMinimumBlock();

  if (products.length === 0) return null;

  return (
    <ModalOrderMinimum
      products={products}
      onUpdateOrder={() => {
        orderMinimumBlockActions.clear();
        navigate("/kiosk/basket");
      }}
    />
  );
};
